import {TaskManagerService} from '../../services/task-manager.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import { MatDialog } from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {TaskManagerState} from '../../store/task-manager.reducer';
import {Location} from '@angular/common';
import {Component} from '@angular/core';
import {TaskManagerTicketListComponent} from './task-manager-ticket-list.component';
import {CommandService} from "@core/services/command.service";
import {Configuration} from "@shared/models/configuration";
import {SnackBarService} from "@core/services/snack-bar.service";
@Component({
    standalone: false,
    selector: 'particle-task-manager-support-list',
  templateUrl: './task-manager-ticket-list.component.html',
  styleUrls: ['./task-manager-ticket-list.component.scss']
})
export class TaskManagerSupportListComponent extends TaskManagerTicketListComponent {
  constructor(protected activatedRoute: ActivatedRoute,
              protected taskManagerStore: Store<TaskManagerState>,
              public dialog: MatDialog,
              protected dialogService: DialogService,
              protected location: Location,
              protected route: Router,
              protected taskManagerService: TaskManagerService,
              protected commandService: CommandService,
              protected snackbarService: SnackBarService) {
    super(activatedRoute, taskManagerStore, dialog, dialogService, location, route, taskManagerService, commandService, snackbarService);
    this.scope = 3;
    this.sourceKey = 'OrbitaxSupportBoardTasks';
    this.isSupportTicketGrid = true;
  }

  protected getBoardId(params: any) {
    return 'orbitax_support';
  }

  protected getBoardUrl(selectedBoard) {
    return `task-manager/support/${this.getTypeView()}`;
  }

  public showBoardView() {
    this.route.navigateByUrl(`task-manager/support/card`);
  }

  public showGridView() {
    this.route.navigateByUrl(`task-manager/support/grid`);
  }

  protected onLoadBoard(selectedBoard) {
    super.onLoadBoard(selectedBoard);
    const config = Configuration.getSmartGridConfig(this.sourceKey);
    config.Parameters['BOARD_ID'] = selectedBoard.id;
    config.Parameters['SCOPE'] = selectedBoard.scopeInt;
    config.Parameters['SHOW_ARCHIVED'] = this.showArchived;
    this.invalidateSubject.invalidate();
  }

}
